import { atom } from 'jotai';
import React from 'react';
import { ToastType } from '@/types/toast';

const toastDataBaseAtom = atom<{
  toastName?: string;
  entityName?: string;
  content?: React.ReactNode;
  type: ToastType;
  isOpen: boolean;
  translationOptions?: Record<string, string>;
}>({ type: 'success', isOpen: false });

export const closeToastAtom = atom(null, (get, set) =>
  set(toastDataBaseAtom, { ...get(toastDataBaseAtom), isOpen: false }),
);

export const toastDataAtom = atom(
  get => get(toastDataBaseAtom),
  (
    get,
    set,
    {
      toastName,
      entityName,
      content,
      translationOptions,
      type,
    }: {
      toastName: string;
      entityName?: string;
      content?: React.ReactNode;
      translationOptions?: Record<string, string>;
      type: ToastType;
    },
  ) =>
    set(toastDataBaseAtom, {
      toastName,
      entityName,
      content,
      type,
      translationOptions,
      isOpen: true,
    }),
);
